export default __webpack_public_path__ + "assets/images/8f613ad388df99f6a664843a011010a0.png";